<template>
<about-us-section :section="section" :section-class="sectionClasses">
  <template slot="content">
    <img :src="section.image" alt="">
  </template>
</about-us-section>
</template>

<script>
import Vue from 'vue'
import AboutUsSection from './AboutUsSection'
import HasSectionHighlights from '@/mixins/HasSectionHighlights'

export default Vue.extend({
  props: ['section', 'namespace'],

  mixins: [HasSectionHighlights],

  components: {
    AboutUsSection,
  },

  computed: {
    sectionClasses() {
      const classes = []

      classes.push('about-us-image-section')

      switch (this.section.image_position) {
        case 'left':
          classes.push('about-us-image-section-left')
          break
      }

      if (this.sectionHighlightClasses) {
        classes.push(this.sectionHighlightClasses)
      }

      return classes
    }
  },

  methods: {
    getSectionNamespace() {
      return this.namespace
    },
  },
})
</script>

<style lang="less">
.about-us-image-section {
  &.about-us-image-section-left {
    .about-us-section-wrapper {
      .about-us-section-heading-wrapper {
        order: 2;
      }

      .about-us-section-content-wrapper {
        @apply px-4 text-center;

        order: 1;
      }
    }
  }
}

@screen lg {
  .about-us-image-section {
    &.about-us-image-section-left {
      .about-us-section-wrapper {
        .about-us-section-content-wrapper {
          @apply text-left;
        }
      }
    }
  }
}
</style>
